import React from 'react'


const defaultBenefits = [
  {
    title: 'Zero blind spots',
    highlight: true,
  },
  {
    title: 'Faster issue resolution',
    highlight: false,
  },
  {
    title: 'Stronger customer trust',
    highlight: false,
  },
]

const FeaturesBenefits = ({ content = [] }) => {
  const benefits = content.length ? content : defaultBenefits

  return (
    <div>
        <section className="relative py-20 px-6 lg:px-12 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row gap-12 justify-center items-center">
          {benefits.map((item, index) => (
            <div
              key={index}
              data-aos="fade-up"
              data-aos-delay={index * 150}
              className={`relative rounded-xl p-8 shadow-sm transition-all duration-300 ${
                item.highlight
                  ? "bg-[url('../images/gradient_bg_small.jpg')]  bg-cover bg-center bg-no-repeat h-[223px] w-[283px] text-white shadow-xl flex flex-col justify-between"
                  : "bg-white border border-gray-100 text-gray-900 hover:shadow-md h-[223px] w-[283px] flex flex-col justify-between"
              }`}
            >
              {/* Icon Circle */}
              <div
                className={`w-14 h-14 rounded-full flex items-center justify-center mb-10 ${
                  item.highlight
                    ? "bg-white/20"
                    : "bg-purple-100 text-purple-600"
                }`}
              >
                <svg
                  className="w-6 h-6"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M12 18v.01M8.21 13.89A4 4 0 1115.79 13.89M12 2a10 10 0 100 20 10 10 0 000-20z"
                  />
                </svg>
              </div>

              {/* Title */}
              <h3 className="text-xl md:text-2xl font-semibold leading-snug">
                {item.title}
              </h3>
            </div>
          ))}
        </div>
      </div>
    </section>
    </div>
  )
}

export default FeaturesBenefits
